import React, { useRef, useCallback, useState, useEffect } from 'react';
import Slider, { Settings } from 'react-slick';
import { albums } from '../data';
import * as S from './styles';

interface AlbumGalleryProps {
  AlbumId: number | undefined;
  onClose: () => void;
}

const AlbumsGallery: React.FC<AlbumGalleryProps> = ({ AlbumId, onClose }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const sliderRef = useRef<Slider>(null);
  const sliderSettings: Settings = {
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 600,
  };
  const handleBack = useCallback(() => {
    setIsOpen(false);
    onClose();
  }, [onClose]);

  const handleClick = useCallback((url: string) => {
    window.open(url, '_blank');
  }, []);

  type Directions = 'next' | 'prev';
  const handleNavigation = useCallback((direction: Directions) => {
    if (sliderRef.current) {
      if (direction === 'next') {
        sliderRef.current.slickNext();
      }
      if (direction === 'prev') {
        sliderRef.current.slickPrev();
      }
    }
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      if (AlbumId) {
        setIsOpen(true);
        sliderRef.current.slickGoTo(AlbumId - 1);
      } else {
        setIsOpen(false);
        sliderRef.current.slickGoTo(0);
      }
    }
  }, [AlbumId]);

  return (
    <S.Modal isOpen={isOpen}>
      <S.BackButton onClick={handleBack}>
        <S.ArrowLeft2 /> Voltar
      </S.BackButton>
      <S.Container>
        <S.Button className="left" onClick={() => handleNavigation('prev')}>
          <S.ArrowLeft />
        </S.Button>
        <S.Button className="right" onClick={() => handleNavigation('next')}>
          <S.ArrowRight />
        </S.Button>

        <Slider ref={sliderRef} {...sliderSettings}>
          {albums.map((album) => (
            <S.Album key={album.id}>
              <S.AlbumCoverWrapper>
                <S.AlbumCover src={album.cover} alt={album.title} />
                <S.PlayButton onClick={() => handleClick(album.url)}>
                  <S.PlayIcon />
                  ouça agora
                </S.PlayButton>
              </S.AlbumCoverWrapper>
              <S.AlbumContent>
                <S.AlbumHeader>
                  <S.AlbumYear>
                    {album.id}
                    <span>{album.year}</span>
                  </S.AlbumYear>
                  <div className="wrapper">
                    <S.AlbumArtist>{album.artist}</S.AlbumArtist>
                    <S.AlbumTitle
                      dangerouslySetInnerHTML={{ __html: album.title }}
                    />
                  </div>
                </S.AlbumHeader>
                <S.AlbumDescription
                  dangerouslySetInnerHTML={{ __html: album.description }}
                />
              </S.AlbumContent>
            </S.Album>
          ))}
        </Slider>
      </S.Container>
    </S.Modal>
  );
};

export default AlbumsGallery;
